import React from "react";
import { Box, Stack, Typography } from "@mui/material";

type Props = {
  title: string;
  icon: React.ReactNode;
  children: React.ReactNode;
};

const MapMarkerRainforestInfoSection = ({ title, icon, children }: Props) => {
  return (
    <Box sx={{ mb: 2 }}>
      <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 0.5 }}>
        <Box sx={{ color: "text.secondary", display: "flex" }}>{icon}</Box>
        <Typography
          variant="caption"
          color="text.secondary"
          fontWeight="bold"
          sx={{ textTransform: "uppercase", letterSpacing: 0.5 }}
        >
          {title}
        </Typography>
      </Stack>
      <Box sx={{ pl: 3.5 }}>{children}</Box>
    </Box>
  );
};

export default MapMarkerRainforestInfoSection;
